import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '../images/logo.svg';

function ImprintPage() {
  const { t } = useTranslation();

  return (
    <section className="imprint content-panel" style={{ minHeight: '80vh' }}> 
      <div className="imprint-logo-container">
        <img src={logo} alt={t('sylentsLogoAlt')} className="imprint-logo" />
      </div>
      <h2 className="panel-title">{t('imprintTitle')}</h2> 
      
      <div className="content">
        <h3 style={{ marginTop: '1.5rem', color: '#17a4b0' }}>{t('imprintCompanyName')}</h3>
        <p style={{ whiteSpace: 'pre-line' }}>{t('imprintAddress')}</p>
        
        <h3 style={{ marginTop: '1.5rem', color: '#17a4b0' }}>{t('imprintManagementHeading')}</h3>
        <p style={{ whiteSpace: 'pre-line' }}>{t('imprintManagementNames')}</p>
        
        <h3 style={{ marginTop: '1.5rem', color: '#17a4b0' }}>{t('imprintContactInfo')}</h3>
        <p style={{ whiteSpace: 'pre-line' }}>{t('imprintContactPhone')}</p>
        <p style={{ whiteSpace: 'pre-line' }}>
          <a href="mailto:hi@sylents.de" style={{ color: 'inherit' }}>{t('imprintContactEmail')}</a>
        </p>
        
        <h3 style={{ marginTop: '1.5rem', color: '#17a4b0' }}>{t('imprintRegisterHeading')}</h3>
        <p style={{ whiteSpace: 'pre-line' }}>{t('imprintRegisterInfo')}</p>
        
        <h3 style={{ marginTop: '1.5rem', color: '#17a4b0' }}>{t('imprintVatHeading')}</h3>
        <p style={{ whiteSpace: 'pre-line' }}>{t('imprintVatInfo')}</p>
        
        <h3 style={{ marginTop: '1.5rem', color: '#17a4b0' }}>{t('imprintDisputeHeading')}</h3>
        <p style={{ whiteSpace: 'pre-line' }}>{t('imprintDisputeInfo')}</p>
        
        <h3 style={{ marginTop: '1.5rem', color: '#17a4b0' }}>{t('imprintLiabilityContentHeading')}</h3>
        <p style={{ whiteSpace: 'pre-line', lineHeight: '1.6' }}>{t('imprintLiabilityContentText')}</p>
        
        <h3 style={{ marginTop: '1.5rem', color: '#17a4b0' }}>{t('imprintLiabilityLinksHeading')}</h3>
        <p style={{ whiteSpace: 'pre-line', lineHeight: '1.6' }}>{t('imprintLiabilityLinksText')}</p>
        
        <h3 style={{ marginTop: '1.5rem', color: '#17a4b0' }}>{t('imprintCopyrightHeading')}</h3>
        <p style={{ whiteSpace: 'pre-line', lineHeight: '1.6' }}>{t('imprintCopyrightText')}</p>
        
        <p style={{ marginTop: '2rem', fontSize: '0.9rem', opacity: 0.7 }}>{t('imprintSource')}</p>
      </div>
    </section>
  );
}

export default ImprintPage; 
 
 
 